/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Project } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class ProjectNumberDataService extends HttpBaseService {

    route = environment.api + 'apps/';

    constructor(private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    validateChargeNo(app: App, project: Project, chargeNo: string): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/project-numbers/${chargeNo}`;
        return this.httpGet(url);
    }

    validateChargeNoForEnterpriseApp(chargeNo: string): Observable<any> {
        const url = `${environment.api}project-numbers/${chargeNo}`;
        return this.httpGet(url);
    }
}
